import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.keys.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'components/Dialogs/TEDialog.vue';
import { dialog } from 'boot/mixins';
import utils from 'src/mixins/utils';
export default {
  name: 'AppDialog',
  mixins: [dialog, utils],
  components: {
    TeDialog: TeDialog
  },
  props: {
    app: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onSave: {
      type: Function,
      default: function _default() {}
    },
    onDelete: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  },
  data: function data() {
    return {
      dragEnter: false,
      localApp: {},
      errors: {},
      tempAvatar: null
    };
  },
  watch: {
    app: {
      handler: function handler(value) {
        this.localApp = _objectSpread(_objectSpread({}, value), {}, {
          avatar: value.avatar ? _objectSpread({}, value.avatar) : null
        });
      },
      immediate: true
    },
    tempAvatar: function tempAvatar(value) {
      if (value) {
        if (!this.localApp.avatar) {
          this.localApp.avatar = {
            avatar_url: ''
          };
        }

        this.localApp.avatar.avatar_url = URL.createObjectURL(value);
      }
    }
  },
  methods: {
    selectFile: function selectFile() {
      if (this.$refs.qFile) {
        this.$refs.qFile.pickFiles();
      }
    },
    onDrop: function onDrop(e) {
      this.dragEnter = false;
      this.tempAvatar = e.dataTransfer.files[0];
    },
    saveApp: function saveApp() {
      var _this = this;

      this.showLoading();

      if (this.localApp.app_id) {
        if (this.tempAvatar) {
          var data = new FormData();
          data.append('image', this.tempAvatar);
          this.$axios.post('/apps/' + this.localApp.app_id + '/avatar', data).then(function () {
            _this.update();
          }).catch(function () {
            _this.hideLoading();
          });
        } else {
          this.update();
        }
      } else {
        this.save();
      }
    },
    save: function save() {
      var _this2 = this;

      this.$axios.post('/apps', this.localApp).then(function (response) {
        _this2.$q.notify({
          message: _this2.$t('components.appDialog.app_created'),
          color: 'positive',
          icon: 'check'
        });

        _this2.onSave(response.data);

        _this2.hideLoading();

        _this2.hide();
      }).catch(function (error) {
        _this2.hideLoading();

        if (error.response && error.response.data && error.response.data.errors) {
          _this2.validateErrors(error.response.data.errors);
        } else {
          console.error(error);
        }
      });
    },
    update: function update() {
      var _this3 = this;

      var changedProperties = this.diff(this.app, this.localApp);

      if (Object.keys(changedProperties).length === 0) {
        this.$q.notify({
          message: this.$t('components.appDialog.app_saved'),
          color: 'positive',
          icon: 'check'
        });
        this.hideLoading();
        this.hide();
      } else {
        this.$axios.put("/apps/".concat(this.localApp.app_id), changedProperties).then(function (response) {
          _this3.$q.notify({
            message: _this3.$t('components.appDialog.app_saved'),
            color: 'positive',
            icon: 'check'
          });

          _this3.onSave(response.data);

          _this3.hideLoading();

          _this3.hide();
        }).catch(function (error) {
          _this3.hideLoading();

          if (error.response && error.response.data && error.response.data.errors) {
            _this3.validateErrors(error.response.data.errors);
          } else {
            console.error(error);
          }
        });
      }
    },
    deleteApp: function deleteApp() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.showLoading();

                _context.next = 3;
                return _this4.onDelete(_this4.localApp);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    validateErrors: function validateErrors(errors) {
      var _this5 = this;

      if (errors) {
        this.errors = errors;
        Object.keys(errors).forEach(function (key) {
          _this5.$refs["app.".concat(key)].validate();
        });
      }
    },
    hideErrors: function hideErrors(error) {
      if (this.errors[error]) {
        this.$refs["app.".concat(error)].resetValidation();
        this.$delete(this.errors, error);
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$root.$on('app:deleted', function () {
      _this6.hideLoading();

      _this6.hide();
    });
    this.$root.$on('app:deletion-cancelled', function () {
      _this6.hideLoading();
    });
  }
};